import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';
import { InterviewAnalysis } from '../job/interview-insights/interview-insights.component';
import { safeGetItem } from '../utils/safe-storage';

@Injectable({
  providedIn: 'root'
})

export class EventServicesService {

  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;
  genai_api_url = environment.HOST.HIRE_GENAI_URL;
  private documentationForms: any[] = [];
  private feedbackForms: any[] = [];
  private OfferForms: any[] = [];
  private testForms: any[] = [];
  userId = (() => {
    const stored = safeGetItem('userDetails');
    if (!stored) {
      return '';
    }
    try {
      return JSON.parse(stored)?.id ?? '';
    } catch {
      return '';
    }
  })();
  interviewInsights$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient, private globalService: GlobalServicesService) { }
  // fast APIs
  // New method to create an event
  createEventFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/events', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getEventsFastApi(
    page = 1,
    size = 100,
    orderBy = 'desc',
    sortBy = 'created_at',
    searchEvent = '',
    eventStatus = 'all'
  ): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy)
      .set('event_status', eventStatus);

    if (searchEvent && searchEvent.trim() !== '') {
      params = params.set('s', searchEvent.trim());
    }
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // New method to update an event by ID
  updateEventFastApi(payload: any, eventId: string): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/events/' + eventId, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // New method to get a specific event by ID
  getSpecificEventFastApi(eventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/events/' + eventId, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getEventOverviewFastApi(eventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/overview`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getEventOverviewStageFastApi(eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(
      `${this.fast_api_url}/events/${eventId}/overview/stages/${stageId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // New method to get a event form data
  getEventFormDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/events/form-data', {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // New method to delete an event by ID
  deleteEventFastApi(eventId: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/events/' + eventId, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // New method to get all events stage candidates
  getEventStageCandidatesFastApi(
    stageId: string,
    eventId: string,
    page: number = 1,
    size: number = 10,
    orderBy: string = 'asc',
    sortBy: string = 'candidate_uuid',
    searchEmail: string = '',
    filters: any = {}
  ): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
    if (searchEmail && searchEmail.trim() !== '') {
      params = params.set('s', searchEmail.trim());
    }

    const fieldMapping: { [key: string]: string } = { jobRole: "job_role_id", jobStatus: "status", isPWD: "pwd_status", arrears: "arrears_status", graduationYear: "end_date", degreeBranch: "specialization", degree: "degree", collegeName: "college_name", };

    if (filters.filterCriteria && filters.filterCriteria.length > 0) {
      filters.filterCriteria.forEach((filter: any) => {
        if (filter.filterValue != null) {
          if (filter.filterField === "collegeName") {
            filter.filterValue = JSON.stringify(filter.filterValue);
          }
          params = params.set(fieldMapping[filter.filterField] || filter.filterField, filter.filterValue);
        }
      });
    }
    return this.http.get<HttpResponse<any>>(
      `${this.fast_api_url}/events/${eventId}/stages/${stageId}/candidates`,
      {
        params,
        observe: 'response',
      }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // get event stage action form data fast api
  getEventStageActionFormDataFastApi(eventId: string, templateType?: string): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    if (templateType) {
      params = params.set('template_type', templateType);
    }
    return this.http.get<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/actions/form-data`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getEventFormDataWithQueryFastApi(eventId: string, dataTypes: string): Observable<HttpResponse<any>> {
    let params = new HttpParams().set('data', dataTypes);
    return this.http.get<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/form-data`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // New method to update an event stage candidate status 
  candidateStageUpdateStatusFastApi(payload: any, stageId: string, eventId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/update-status`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  candidateStageMoveStageFastApi(payload: any, stageId: string, eventId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/move-stage`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  sendTestLinkFastApi(payload: any, stageId: string, eventId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/send-test-link`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getRecruiterListByEventFastApi(eventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/interviews/interviewers`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getInterviewerAvailability(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/integrations/conference/ms_teams/availability`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  updateInterviewFastApi(eventId: string, stageId: string, interviewId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/interviews/${interviewId}`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  deleteInterviewFastApi(eventId: string, stageId: string, interviewId: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/interviews/${interviewId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // Get meeting token 
  getMeetingToken(userName: string, interviewUuid: string, isCandidate: boolean, avatarUrl?: string): Observable<any> {
    const data = {
      "interview_uuid": interviewUuid,
      "user_name": userName,
      "isCandidate": isCandidate,
      "avatar_url": avatarUrl
    }

    let headers = new HttpHeaders({
      'use-candidate-token': isCandidate.toString()
    });

    if (isCandidate) {
      const candidateTokenString = safeGetItem('token');
      const candidateToken = candidateTokenString ? JSON.parse(candidateTokenString) : null;
      if (candidateToken && candidateToken.access_token) {
        headers = headers.set('token', candidateToken.access_token);
      }
    }
    return this.http.post(this.fast_api_url + '/events/stages/jitsi/generate-token', data, {
      observe: 'response',
      headers: headers
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getOpenIdeFastApi(candidateId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/${candidateId}/stages/${stageId}/interviews/open-ide`, {
      observe: 'response',
      headers: new HttpHeaders({ 'use-candidate-token': 'true' })
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }


  // COLUMN APIs
  getUserPreferencesFastApi(type: string): Observable<any> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/user-preferences/metadata/' + type, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  saveUserPreferencesFastApi(payload: any, type: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/user-preferences/' + type, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  deleteUserPreferencesFastApi(eventId: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/user-preferences/' + eventId, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  bulkInviteFileDownloadFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/invite/template`, {
      observe: 'response',
      responseType: 'blob' as 'json',  // Assuming it's a file download
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  bulkInviteFastApi(payload: any, eventId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/candidates/bulk-invite`, payload, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  eventStageCandidateExportFastApi(eventId: string, stageId: string, payload: any, filters: { [key: string]: any } = {}): Observable<HttpResponse<any>> {
    // 3. Makes a POST request expecting a JSON response
    return this.http.post<any>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/candidates/export`, payload, {
      observe: 'response'
      // 'responseType' is removed to default to JSON
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  sendInterviewLinkFastApi(payload: any, eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/send-interview-link`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  sendInterviewLinkSampleExportFastApi(eventId: string, stageId: string, type: string = 'all'): Observable<HttpResponse<any>> {
    return this.http.post<Blob>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/actions/send-interview-link/template?export=${type}`, null, {
      observe: 'response',
      responseType: 'blob' as 'json'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  sendCandidateMoveStageTemplateFastApi(eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.get<Blob>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/actions/move-stage/template`, {
      observe: 'response',
      responseType: 'blob' as 'json'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  bulkCandidateMoveStageFastApi(payload: any, eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/actions/bulk-move-stage`, payload, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  bulkInterviewLinkFastApi(payload: any, eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/actions/send-interview-link/bulk`, payload, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  bulkTestLinkFastApi(payload: any, eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/actions/send-test-link-bulk`, payload, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  InterviewAdminJoinFastApi(eventId: string, interviewId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/interviews/${interviewId}/admin/join`, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  getCandidateDetailsFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/interviews/details`, {
      observe: 'response',
      headers: new HttpHeaders({ 'use-candidate-token': 'true' })
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  updateInterviewStatusFastApi(payload: any, candidateId: String, StageId: String, interviewId: String): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + `/candidates/${candidateId}/stages/${StageId}/interviews/${interviewId}/update-status`, payload, {
      observe: 'response',
      headers: new HttpHeaders({ 'use-candidate-token': 'true' })
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  adminUpdateInterviewStatusFastApi(payload: any, eventId: string, interviewId: string): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/interviews/${interviewId}/admin/update-status`, payload, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  sendMessageWSFastApi(payload: any): Observable<any> {
    return this.http.post(this.fast_api_url + '/events/interviews/websocket/send-message', payload);
  }

  getFeedbackTestDetailsFastApi(eventId: string, candidateId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/candidates/${candidateId}/feedback-tests/details`, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  getFilterFormData(EventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/candidates/filters/form-data?event_uuid=' + EventId, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  exportAllEvents(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.fast_api_url}/events/export`, payload, {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }
  setForms(documentation: any[], feedback: any[], test: any[], Offer: any[]) {
    this.documentationForms = documentation;
    this.feedbackForms = feedback;
    this.testForms = test;
    this.OfferForms = Offer;
  }

  // Add methods to get these forms if needed
  getDocumentationForms() {
    return this.documentationForms;
  }

  getFeedbackForms() {
    return this.feedbackForms;
  }

  getTestForms() {
    return this.testForms;
  }

  getOfferForms() {
    return this.OfferForms;
  }

  // Interview Analysis

  createInterviewInsightsFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      `${environment.HOST.HIRE_GENAI_URL}/interview/insights`, payload,
      {
        observe: 'response'
      }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getInterviewInsightsFastApi(payload: any): Observable<any> {
    const url = `${environment.HOST.HIRE_GENAI_URL}/interview/insights/event/${payload.event_uuid}/stage/${payload.stage_uuid}/candidate/${payload.candidate_uuid}/interview/${payload.interview_uuid}/job_role_id/${payload.job_role_id}`;

    return this.http.get<any>(
      url,
      {
        observe: 'response'
      }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!(error.status === 404 && error.error?.detail === 'No insights found.')) {
          this.globalService.handleError(error);
        }
        return throwError(() => error);
      })
    );
  }

  // Vimeo Upload APIs
  vimeoCreateUpload(fileSize: number): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      `${this.fast_api_url}/vimeo/upload-url`,
      { file_size: fileSize },
      { observe: 'response' }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  vimeoConfirmUpload(videoUri: string, interviewUuid: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      `${this.fast_api_url}/vimeo/confirm-upload`,
      { video_uri: videoUri, interview_uuid: interviewUuid },
      { observe: 'response' }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  vimeoVideoStatus(interviewUuid: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(
      `${this.fast_api_url}/vimeo/video-status/${interviewUuid}`,
      { observe: 'response' }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  uploadTranscript(interviewUuid: string, transcript: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      `${this.genai_api_url}/interview/transcript`,
      { interview_uuid: interviewUuid, transcript: transcript },
      { observe: 'response' }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getTranscript(interviewUuid: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(
      `${this.genai_api_url}/interview/transcript/${interviewUuid}`,
      { observe: 'response' }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 404) {
          this.globalService.handleError(error);
        }
        return throwError(() => error);
      })
    );
  }

  syncTestScoresFastApi(eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(
      `${this.fast_api_url}/events/${eventId}/stages/${stageId}/candidates/fetch-scores`,
      {
        observe: 'response',
      }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  syncContestFastApi(eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      `${this.fast_api_url}/manage-contest/${eventId}/sync_contest/${stageId}`,
      {},
      {
        observe: 'response',
      }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // AI Interview Agents
  getAgentsFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/agents', {
      observe: 'response',
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

}
